import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { readAllNotifications } from '../../services';
import { getNotificationsInfiniteQueryKey } from '../keys';

export const useReadAllNotificationsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown>({
    async mutationFn() {
      await readAllNotifications();
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getNotificationsInfiniteQueryKey({}) });
    },
  });
};
